export default __webpack_public_path__ + "static/media/chisom.5e1c6dcc.webp";